import React from 'react'
import { LuCrown } from "react-icons/lu";
import SeactionHeader from '../seactionheader/SeactionHeader';
import { programs } from "../../data";
import Card from '../../ui/Card';
import { Link } from 'react-router-dom';
import { AiFillCaretRight } from "react-icons/ai";

function program() {
  return (
    <section className='programs'>
        <div className="container programs__container">
            <SeactionHeader icon={<LuCrown/>} title="programs"/>
          
          <div className="programs__wrapper">
            {
              programs.map(({id, icon, title, info, path}) => {
                  return(
                    <Card className="programs__program" key={id}>
                        <span>{icon}</span>
                        <h4>{title}</h4>
                        <small>{info}</small>
                        <Link to={path} className="btn sm">
                          learn more
                          <AiFillCaretRight />
                        </Link>
                    </Card>
                  )
              })
            }
          </div>
        </div>
    </section>
  )
}

export default program